export const typesPrestation = [
  {
    label: "Formation",
    options: [
      { label: "Préscolaire", value: "Préscolaire" },
      { label: "Primaire", value: "Primaire" },
      { label: "Secondaire I", value: "Secondaire I" },
      { label: "Secondaire II", value: "Secondaire II" },
      {
        label: "Orientation professionnelle",
        value: "Orientation professionnelle",
      },
      { label: "Enseignement spécialisé", value: "Enseignement spécialisé" },
      { label: "Services psychosociaux", value: "Services psychosociaux" },
      { label: "Autres (formation)", value: "Autres (formation)" },
    ],
  },
  {
    label: "Santé",
    options: [
      { label: "Hôpital (stationnaire)", value: "Hôpital (stationnaire)" },
      { label: "Hôpital (ambulatoire)", value: "Hôpital (ambulatoire)" },
      {
        label: "Cabinet médical ou centre de santé",
        value: "Cabinet médical ou centre de santé",
      },
      {
        label: "Psychiatrie ou psychothérapie (stationnaire)",
        value: "Psychiatrie ou psychothérapie (stationnaire)",
      },
      {
        label: "Psychiatrie ou psychothérapie (ambulatoire)",
        value: "Psychiatrie ou psychothérapie (ambulatoire)",
      },
      { label: "Réadaptation ou thérapie", value: "Réadaptation ou thérapie" },
      { label: "Expertise", value: "Expertise" },
      { label: "Conseil ou prévention", value: "Conseil ou prévention" },
      { label: "Autres (santé)", value: "Autres (santé)" },
    ],
  },
  {
    label: "Social",
    options: [
      { label: "Aide sociale", value: "Aide sociale" },
      { label: "ORP", value: "ORP" },
      { label: "Autorité et office", value: "Autorité et office" },
      {
        label: "Protection de l’enfant et de l’adulte",
        value: "Protection de l’enfant et de l’adulte",
      },
      { label: "Service de consultation", value: "Service de consultation" },
      { label: "Office de l’état civil", value: "Office de l’état civil" },
      { label: "Autres (social)", value: "Autres (social)" },
    ],
  },
  {
    label: "Asile",
    options: [
      { label: "Représentation juridique", value: "Représentation juridique" },
      {
        label: "Consultation pour la procédure d’asile",
        value: "Consultation pour la procédure d’asile",
      },
      {
        label: "Conseil en vue d’un retour",
        value: "Conseil en vue d’un retour",
      },
      {
        label: "Soins médicaux dans un centre fédéral pour requérants d’asile",
        value: "Soins médicaux dans un centre fédéral pour requérants d’asile",
      },
      {
        label: "Soins médicaux dans un centre cantonal",
        value: "Soins médicaux dans un centre cantonal",
      },
      { label: "Conseil", value: "Conseil" },
      { label: "Autres (asile)", value: "Autres (asile)" },
    ],
  },
  {
    label: "Autorités et tribunaux",
    options: [
      { label: "Justice / Tribunal", value: "Justice / Tribunal" },
      { label: "Police", value: "Police" },
      {
        label: "Autres (autorités et tribunaux)",
        value: "Autres (autorités et tribunaux)",
      },
    ],
  },
];
export const mainTypesPrestation = [
  {
    label: "Formation",
    value: "Formation",
  },
  {
    label: "Santé",
    value: "Santé",
  },
  {
    label: "Social",
    value: "Social",
  },
  {
    label: "Asile",
    value: "Asile",
  },
  {
    label: "Autorités et tribunaux",
    value: "Autorités et tribunaux",
  },
];
